import React from "react";
import { RippleButton } from "../../components/RippleButton";
import phoneImg from "../../assets/images/phone.webp";
import resumePdf from "../../assets/files/Resume Ya'suf Dany.pdf";

export const AboutSection: React.FC = () => {
  const handleDownloadResume = () => {
    window.open(resumePdf, "_blank");
  };

  return (
    <div className="w-full h-full flex items-center justify-center px-6 py-8 md:p-[2vw] z-10 relative">
      <div className="flex flex-col md:flex-row items-center justify-center w-full gap-6 md:gap-0">
        {/* Mockup Phone Illustration */}
        <div className="flex justify-center items-center mx-[1.6vw] animate-[slideLeft_0.8s_ease-out]">
          <img
            src={phoneImg}
            alt="Phone Mockup"
            className="w-[70vw] max-w-[200px] md:w-[18vw] md:max-w-none md:h-auto object-contain pointer-events-none drop-shadow-2xl"
          />
        </div>

        {/* About Info Panel */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left w-full md:w-[36vw] animate-[slideRight_0.8s_ease-out] select-text">
          <h2 className="font-nunito text-[24px] md:text-[36px] font-black text-dark mb-4">
            About Me
          </h2>
          <p className="font-nunito text-sm md:text-[24px] text-dark/50 leading-relaxed">
            A passionate programmer who is willing to explore new skills and
            collaborations. experienced in Mobile Development both Android and
            iOS using Flutter, I loved to work on challenging and stunning UI
            Design.
          </p>

          <RippleButton
            text="Download Resume"
            onTap={handleDownloadResume}
            padding="px-8 py-3.5"
            enableShadow={true}
            className="mt-8 font-rubik text-base font-normal"
          />
        </div>
      </div>
    </div>
  );
};
